module.exports = __webpack_public_path__ + "img/smartHome-hd.174099b6.jpg";